<template>
  <div class="onboarding-signup-step-origin">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title-optional">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.ORIGIN.@TITLE")) }}
          </h2>

          <OriginForm v-model:origin="originInscription" v-model:other-value="otherValue" :input-values="inputValues" />
        </QPage>
      </transition>

      <QFooter>
        <div class="q-mt-xl">
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { SHORT_TEXT_LENGTH_LIMIT, FORM_ORIGIN_INPUT_VALUES } from "@core/constants";
  import { UserStorageManager } from "@core/managers/user-storage.manager";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { PosthogManager } from "@etab/managers/posthog.manager";
  import { KochavaManager } from "@core/managers/kochava.manager";
  import { DataLayerManager } from "@core/managers/datalayer-manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { reactive, ref, computed, inject, onMounted } from "vue";
  import { ISignup } from "@core/models";
  import { useTransition } from "@core/composables";
  import { useSignup } from "@etab/composables";
  import OriginForm from "@etab/components/onboarding/signup/Origin.component.vue";

  const { transition } = useTransition();
  const signupStore = useSignupStore();
  const { $_completeCreationProcess } = useSignup();
  const $posthog = inject("$posthog");

  const originInscription = ref("");
  const otherValue = ref("");
  const inputValues = reactive(FORM_ORIGIN_INPUT_VALUES);
  const OTHER = ref("other");

  const getFormValue = computed(() => {
    return originInscription.value === OTHER.value ? getFormattedOtherValue.value : originInscription.value;
  });

  const getFormattedOtherValue = computed(() => {
    return `Autre ${otherValue.value}`;
  });

  const onSubmit = async function () {
    const signupStore = useSignupStore();
    if (isCommentValid()) {
      signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.originInscription]: getFormValue });
      await $_completeCreationProcess({ signupData: signupStore[GETTER_SIGNUP_GET] });
      await signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.password]: null });
      const user = await UserStorageManager.getUser();
      const utmTracker = await UserStorageManager.getUtmTracker();
      setTimeout(() => {
        if ($posthog && utmTracker) $posthog.capture("origin_tracker", { $utm_tracker: utmTracker, $user_id: user.email });
        UserStorageManager.removeUtmTracker();
      }, 500);
      TrackingManager.addEvent({
        event: FIREBASE_EVENTS.FUNNEL,
        step: "step11_origin",
      });
      TrackingManager.addEvent({
        event: FIREBASE_EVENTS.FUNNEL_SIGNUP,
      });
      KochavaManager.sendEventSignup();
      await PosthogManager.setUserIdentify();
      DataLayerManager.updateHistoryState({ email: user.email });
    }
  };

  const isCommentValid = function () {
    return getFormValue.value?.length <= SHORT_TEXT_LENGTH_LIMIT;
  };

  onMounted(() => {
    originInscription.value = signupStore[GETTER_SIGNUP_GET][ISignup.originInscription];
  });
</script>
